<script setup lang="ts">
defineEmits<{ (e: 'close'): void; (e: 'wizard'): void; (e: 'report'): void }>()

const faqs = [
  { q: 'What is SnipCell?', a: 'SnipCell lets you snip text, sums and tables from PDFs and images straight into Excel cells — without retyping.' },
  { q: 'Which files can I import?', a: 'PDFs and images (PNG, JPG, BMP, GIF, TIFF, WebP). Word documents are imported by converting their pages to images.' },
  { q: 'How do I create a Text snip?', a: 'Pick the Text mode, then draw a box around the text on the page. The extracted text is written into the selected Excel cell.' },
  { q: 'What happens after I snip into Excel?', a: 'The snip lands in the active cell, colour-coded by mode, and stays linked to its spot in the document — click the cell to jump back to the source, and vice versa.' },
  { q: 'Which Snip mode should I use?', a: 'Text for plain text, Sum to total numbers into a formula, Table for grids (with borders), Validation for a ✔, Exception for an X.' },
  { q: 'How does Table snip work?', a: 'It splits the selected region into rows and columns and writes a bordered, auto-fitted block of cells starting at the selected cell.' },
  { q: 'Can I add comments?', a: 'Yes — add a note to any snippet from the snippets list. Pin comments on the page itself is also supported on the page view.' },
  { q: 'What is the document tree for?', a: 'It lists your imported documents and their pages so you can navigate, search, and manage snippets while you work in Excel.' },
  { q: 'Why did my snip go into the wrong cell?', a: 'Snips go into the currently selected cell (advancing right to the first empty one). Select the target cell before you snip.' },
  { q: 'Where do I get support?', a: 'Use the Contact link below — it opens our support page in your browser.' },
]
</script>

<template>
  <div class="overlay" @click.self="$emit('close')">
    <div class="panel">
      <header class="hd">
        <strong>Help &amp; FAQ</strong>
        <button class="x" @click="$emit('close')">×</button>
      </header>
      <div class="body scroll">
        <details v-for="(f, i) in faqs" :key="i" class="faq">
          <summary>{{ f.q }}</summary>
          <p>{{ f.a }}</p>
        </details>
      </div>
      <footer class="ft">
        <button class="gs" @click="$emit('wizard')">▶ Getting started</button>
        <button class="gs" @click="$emit('report')">Report a problem</button>
        <a href="https://accounts.snipcell.com/contact/" target="_blank" rel="noopener">Contact →</a>
      </footer>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: grid;
  place-items: center;
  z-index: 50;
  padding: 16px;
}
.panel {
  background: var(--bg);
  border-radius: 8px;
  width: 100%;
  max-width: 360px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}
.hd {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}
.hd .x { margin-left: auto; border: none; background: none; font-size: 18px; color: var(--muted); }
.body { padding: 6px 12px; overflow: auto; }
.faq { padding: 7px 0; border-bottom: 1px solid var(--line); }
.faq summary { cursor: pointer; font-weight: 600; font-size: 13px; }
.faq p { margin: 6px 0 0; color: var(--muted); font-size: 12px; }
.ft { padding: 10px 12px; border-top: 1px solid var(--line); display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.ft a { color: var(--brand); font-size: 13px; font-weight: 600; }
.gs { font-size: 12px; padding: 4px 8px; }
</style>
